import React from "react";
import PropTypes from "prop-types";
import { InputAdornment, TextField, useTheme } from "@mui/material";

function TextInput({
  InputStartIcon,
  InputEndIcon,
  onEndIconClick,
  fullWidth,
  readonly,
  defaultStyle,
  style,
  ...props
}) {
  return (
    <TextField
      fullWidth={fullWidth}
      {...props}
      InputProps={{
        readOnly: readonly,
        startAdornment: InputStartIcon && (
          <InputAdornment position="start">{InputStartIcon}</InputAdornment>
        ),
        endAdornment: InputEndIcon && (
          <InputAdornment
            position="end"
            sx={{ cursor: "pointer" }}
            onClick={onEndIconClick}
          >
            {InputEndIcon}
          </InputAdornment>
        ),
      }}
      //   sx={defaultStyle ? useStyle : style}
    />
  );
}

TextInput.propTypes = {
  InputStartIcon: PropTypes.element,
  InputEndIcon: PropTypes.element,
  fullWidth: PropTypes.bool,
  readonly: PropTypes.bool,
};

TextInput.defaultProps = {
  fullWidth: true,
  readonly: false,
};

export default TextInput;
